import generic_backend_request_post from 'functions/server/generic_backend_request_post';

async function submit_message({name='', email='', message=''}) {
    /**
     * This function sends a POST request to the backend server to submit a message.
     * It takes in the name, email, and message and returns the response from the server.
     * 
     * @param {string} name - The name of the user submitting the message.
     * @param {string} email - The email of the user submitting the message.
     * @param {string} message - The message being submitted.
     * 
     * @returns {Object} - The response from the server.
     * 
     */
    const requestJson = {
        "name": name,
        // pydantic v2 rejects '' for Optional[EmailStr] — omit when absent.
        ...(email ? { email } : {}),
        "message": message
    }
    // '/submit_message' was the Flask-era path; it died in the December
    // migration and every submission since 404'd at the gateway.
    const retJson = await generic_backend_request_post(requestJson, '/contact');
    return retJson;
}

export default submit_message